export default __webpack_public_path__ + "static/media/Swiss721BTMedium.9010b80b.woff2";